'use client';

import NextLink from 'next/link';

import ErrorImage from '@/assets/images/error.jpg';
import ContentMediaBlock from '@/components/content-media-block';
import MuiLegacyStyleProviders from '@/components/mui-legacy-style-providers';
import { SectionHeading } from '@/components/type';
import { Button } from '@/components/ui/button';
import URLS from '@/constants/urls';

export default function VehicleNotFound() {
  return (
    <main className="flex-1 bg-white">
      <MuiLegacyStyleProviders>
        <ContentMediaBlock
          imageOverride={ErrorImage}
          heading="We don't seem to have results for that vehicle."
          imageOverrideAlt="No results found"
          imageAlignment="right"
        >
          <SectionHeading className="mt-3 md:mt-4 xl:mt-6">
            {'Just a note that having no results isn\u2019t a reflection of the cars safety.'}
          </SectionHeading>
          <SectionHeading className="mt-3 md:mt-4 xl:mt-6">
            {
              'Instead the registration number you\u2019ve looked up might belong to a make or model we don\u2019t list. Please try again or try searching by make or model.'
            }
          </SectionHeading>
          <SectionHeading className="mt-3 md:mt-4 xl:mt-6">
            {'If you still can\u2019t find your car or have any questions '}
            <NextLink href="/contact-us" className="underline">
              please contact us
            </NextLink>
            .
          </SectionHeading>
          <Button asChild className="mt-6 w-full lg:w-auto">
            <NextLink href={URLS.HOME}>Search again</NextLink>
          </Button>
        </ContentMediaBlock>
      </MuiLegacyStyleProviders>
    </main>
  );
}
